import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { AuxiliaresModule } from '../../../auxiliares/auxiliares.module';
import { AlertasSeguridadRoutingModule } from './alertas-seguridad.routing.module';
import { AlertasSeguridadComponent } from './listado/alertas-seguridad.component';
import { DetalleAlertaSeguridadComponent } from './detalle-alerta-seguridad/detalle-alerta-seguridad.component';
import { MapaAlertasSeguridadComponent } from './mapa/mapa-alertas-seguridad.component';
import { FlotanteAlertasSeguridadComponent } from './mapa/flotante-alertas-seguridad/flotante-alertas-seguridad.component';
import { MapaFacilV2Component } from '../../../auxiliares/mapbox/mapa-facil-v2.component';
import { DatePickerComponent } from '../../../componentes/date-picker/date-picker.component';

@NgModule({
  declarations: [
    AlertasSeguridadComponent,
    DetalleAlertaSeguridadComponent,
    MapaAlertasSeguridadComponent,
    FlotanteAlertasSeguridadComponent,
  ],
  imports: [
    CommonModule,
    AuxiliaresModule,
    AlertasSeguridadRoutingModule,
    MatDialogModule,
    MapaFacilV2Component,
    DatePickerComponent,
  ],
})
export class AlertasSeguridadModule {}
